import { CoreBaseApiResult, CoreBaseApi, CoreApiRequestMethod } from "../../cvp-webgames-core/Api/CoreBaseApi";
import { CoreBaseApiEndpoint } from "../../cvp-webgames-core/Api/CoreBaseApiEndpoint";
import Tools from "../../cvp-webgames-core/Misc/Tools";

export class ChatGptEndpoint extends CoreBaseApiEndpoint {
    public askQuestion(question: string): Promise<CoreBaseApiResult<string>> {
        return this.api.sendRequest('api/ChatGpt/AskQuestion', CoreApiRequestMethod.POST, {
            question: question
        }, undefined, 'This is a mock response from chat gpt', () => {}, true)
    }

    constructor(api: CoreBaseApi) {
        super(api)
    }
}